import React, { Component } from 'react';
import Api from './Api'

class PostFeedback extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      feedback: props.post.feedback,
      feedbackMessage: '',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ feedbackMessage: event.target.value });
  }

  handleKeyPress = (event) => {
    if(event.key === 'Enter' && this.feedbackInput.value.length >= 10){
      this.sendFeedbackMessage(event)
    }
  }

  async deleteFeedbackMessage(event) {
    event.preventDefault()
    this.feedbackInput.value = '';
    this.setState(prevState => {
      prevState.feedback = prevState.feedback || {}
      prevState.feedback.given = prevState.feedback.given || {}
      prevState.feedback.given.message = ''
      prevState.feedbackMessage = ''
      return prevState
    }, () => {
      this.feedbackInput.focus();
    });
  }

  async sendPostFeedbackReaction(event, feedbackReaction) {
    event.preventDefault()
    this.setState(prevState => {
      prevState.feedback = prevState.feedback || {}
      prevState.feedback.given = prevState.feedback.given || {}
      prevState.feedback.given.reaction = feedbackReaction
      return prevState
    });
    await Api.sendPostFeedbackReaction({
      postId: this.props.post.id,
      feedbackReaction: feedbackReaction
    })
  }

  async sendFeedbackMessage(event) {
    event.preventDefault()
    this.setState(prevState => {
      prevState.feedback = prevState.feedback || {}
      prevState.feedback.given = prevState.feedback.given || {}
      prevState.feedback.given.message = this.state.feedbackMessage
      return prevState
    });
    await Api.sendPostFeedbackMessage({
      postId: this.props.post.id,
      feedbackMessage: this.state.feedbackMessage
    })
  }

  render() {
    const { feedback } = this.state
    const feedbackGiven = feedback && feedback.given
    const feedbackMessage = feedbackGiven && feedback.given.message
    const feedbackReation = feedbackGiven && feedback.given.reaction

    return (
    <div className="feedback-container">
      <div className="reactions">
        <span className="emoji">
          <img src="./assets/emoji-negative.svg" 
               alt="emoji negative reaction" 
               className={ !feedbackGiven || feedbackReation === 'negative' ? '' : 'emoji-unselected'}
               onClick={(event) => this.sendPostFeedbackReaction(event, 'negative')} 
               title="Não gostei" />
        </span>
        <span className="emoji">
          <img src="./assets/emoji-neutral.svg" 
               alt="emoji neutral reaction" 
               className={ !feedbackGiven || feedbackReation === 'neutral' ? '' : 'emoji-unselected'}
               onClick={(event) => this.sendPostFeedbackReaction(event, 'neutral')}
               title="Normal" />
        </span>
        <span className="emoji">
          <img 
            src="./assets/emoji-positive.svg" 
            alt="emoji positive reaction" 
            className={ !feedbackGiven || feedbackReation === 'positive' ? '' : 'emoji-unselected'}
            onClick={(event) => this.sendPostFeedbackReaction(event, 'positive')}
            title="Gostei" />
        </span>
      </div>
      <div className="feedback-message">

        <input type="text"
              name="feedback" 
              className="feedback"
              disabled={feedbackMessage ? 'disabled': ''}
              ref={(input) => this.feedbackInput = input}
              defaultValue={feedbackMessage} 
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
              placeholder={feedback.placeholder} />

          { feedbackMessage ? (
            <button className="feedback-submit" 
              onClick={(event) => this.deleteFeedbackMessage(event)}>
              <img className="delete" src="./assets/icon-edit-pencil.svg" alt="edit" title="Editar feedback" />
            </button>
          ) : ( 
            <button className="feedback-submit" 
              onClick={(event) => this.sendFeedbackMessage(event)}
              disabled={feedbackMessage || this.state.feedbackMessage.length < 10 ? 'disabled': ''}>
              <img className="send" src="./assets/icon-send.svg" alt="send arrow" title="Enviar feedback" />
            </button>
          )}
          
      </div>
    </div>
    )
  }
}

export default PostFeedback;